export default "__VITE_ASSET__C$rBcZaS__"